<template>
<div class="multiple-meeting-form">
  <meeting-form 
    ref="meetingForm"
    v-for="plan in selectedMeetingPlans" 
    :key="`${plan.cartInfo.add_time}`" 
    :plan="plan" 
    :can-remove="canRemoveMeetingPlan" 
    :can-add-more="!!addAnotherMeetingText"
    :is-multiple-mode="isMultipleMode"
    :ctx="ctx"
  />
  <zm-button 
    v-if="!!addAnotherMeetingText"
    data-testid="add-another-meeting-plan-btn"
    type="text"
    class="opc-add-another-meeting-plan-btn"
    @click="addAnotherMeetingPlan">
    {{ addAnotherMeetingText }}
  </zm-button>
</div>
</template>
<script>
import MeetingForm from '@/plans/ZOOM_MEETING/components/meeting-form.vue';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'MultipleMeetingForm',
  components: {
    MeetingForm,
  },
  props: {
    ctx: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'planMapFlat', 'routerTempData']),

    allMeetingPlans() {
      return this.planMapFlat.filter(plan => plan.type === planTypes.ZOOM_MEETING);
    },
    selectedMeetingPlans() {
      return this.getSelectedPlans.filter(plan => plan.type === planTypes.ZOOM_MEETING).sort((a, b) => {
        if (!a.cartInfo.add_time) return -1;
        if (!b.cartInfo.add_time) return 1;
        return a.cartInfo.add_time - b.cartInfo.add_time;
      });
    },
    currentCategory() {
      return this.selectedMeetingPlans[0]?.category;
    },
    selectedCycles() {
      return this.selectedMeetingPlans.map(plan => plan.billing_cycle);
    },
    meetingPlansGroupByCycle() {
      const map = {
        [BILLING_CYCLE.MONTHLY]: { list: [], selected: null, groupKey: BILLING_CYCLE.MONTHLY },
        [BILLING_CYCLE.ANNUAL]: { list: [], selected: null, groupKey: BILLING_CYCLE.ANNUAL },
      };
      this.allMeetingPlans.filter(p => p.category === this.currentCategory).forEach(p => {
        let k = '';
        if (BILLING_CYCLE.ANNUAL === p.billing_cycle) {
          k = BILLING_CYCLE.ANNUAL;
        } else if (BILLING_CYCLE.MONTHLY === p.billing_cycle) {
          k = BILLING_CYCLE.MONTHLY;
        }
        if (!k || !map[k]?.list) return;
        map[k].list.push(p);
        if (p.cartInfo.selected_number > 0) {
          map[k].selected = p;
        }
      });
      return map;
    },

    showAddAnotherMeetingPlan() {
      return Object.values(this.meetingPlansGroupByCycle).some(item => !item.selected);
    },
    canRemoveMeetingPlan() {
      return this.selectedMeetingPlans.length > 1;
    },
    restMeetingPlan() {
      return Object.values(this.meetingPlansGroupByCycle).find(item => !item.selected && item.list.length > 0);
    },
    addAnotherMeetingText() {
      if (!this.ctx.supportMSQ) return '';
      if (this.restMeetingPlan?.groupKey === BILLING_CYCLE.MONTHLY) {
        return this.$t('billing.add_monthly_plan');
      } else if (this.restMeetingPlan?.groupKey === BILLING_CYCLE.ANNUAL) {
        return this.$t('billing.add_annual_plan');
      }
      return '';
    },
    isMultipleMode() {
      const canAddMeetingList = Object.values(this.meetingPlansGroupByCycle).filter(item => item.list.length > 0);
      return canAddMeetingList.length > 1;
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    addAnotherMeetingPlan() {
      const firstPlan = this.restMeetingPlan.list[0];
      if (firstPlan) {
        this.updateSelectPlan({
          plan_code: firstPlan.plan_code,
          cartInfo: { selected_number: 1, add_time: new Date().getTime() },
        });
        this.$nextTick(() => {
          const firstFocusableInput = this.$refs.meetingForm[this.$refs.meetingForm.length - 1]?.$el?.querySelector('input');
          if (firstFocusableInput) {
            firstFocusableInput.focus();
          }
        });
      }
    },
  },
  mounted() {
    const targetPlan = this.routerTempData?.targetPlan;
    if (targetPlan) {
      this.$nextTick(() => {
        this.$refs.meetingForm?.forEach(item => {
          if (item.$props.plan?.plan_code === targetPlan.plan_code) {
            if (item.$el?.querySelector('input')) {
              item.$el?.querySelector('input')?.focus();
              return;
            }
          }
        });
      });
    }
  }
}
</script>

<style lang="scss">
.multiple-meeting-form {
  .opc-add-another-meeting-plan-btn {
    width: 100%;
  }
}
</style>
